import { BasePageProps, BasePageState, basePageInitialState } from '../BasePage'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface CyberPageProps extends BasePageProps {}

//----- 

type CyberState = {
    dispositiviConnessi: string | undefined
    acquistiOnline: boolean | undefined

    dispositiviConnessiError?: string
    acquistiOnlineError?: string
}

export type CyberPageState = CyberState & BasePageState


export const cyberInitialState : CyberPageState = {
    ...basePageInitialState,
    ...{
        dispositiviConnessi: undefined,
        acquistiOnline: undefined,

        dispositiviConnessiError: undefined,
        acquistiOnlineError: undefined,
    }
}

export const cyberUpdate = createAction<CyberPageState>('cyber/update')

export const cyberReducer = createReducer ( 
    cyberInitialState,
    (builder) => {
        builder.addCase(cyberUpdate, (state, action) => {
            return action.payload as CyberPageState
        })
    }
)

export type CyberRootState = ReturnType<typeof store.getState>
export type CyberDispatch = typeof store.dispatch
